RS.Utils.Compare = (function() {

	var COMPARE_COOKIE_SEPARATOR = '~';
	var COMPARE_PREFIX = 'compare_';
	var MAX_PRODUCTS_TO_COMPARE = 8;

	/**
	 *  Function to add or remove stock numbers from the compare cookie based on product selection/removal
	 * @param {Object} checkBoxObject
	 * @param {boolean} isProductPage
	 * @param {boolean} isNewTNPage
	 */
	function updateCompareCookie(checkBoxObject, isProductPage, isNewTNPage) {
		var compareCookie = RS.Utils.Cookies.getCookie('compareProducts');
		var rsStockNumber = checkBoxObject.id.substr(COMPARE_PREFIX.length);
		if (checkBoxObject.checked) {
			if (isCompareLimitReached(compareCookie)) {
				showCompareLimitPopup(isNewTNPage);
				checkBoxObject.checked = false;
			} else {
				compareCookie = addProductToCookie(rsStockNumber, compareCookie);
				setCompareContainerDisplay(checkBoxObject, true, isNewTNPage);
			}
		} else {
			compareCookie = removeProductFromCookie(rsStockNumber, compareCookie);
			setCompareContainerDisplay(checkBoxObject, false, isNewTNPage);
		}
		RS.Utils.Cookies.setCookie('compareProducts', compareCookie, 0);
		updatePageSpecificData(isProductPage, checkBoxObject.checked, compareCookie);
	}

	/**
	 * Utility function to set background to product being compared
	 * @param {element} element - checkbox trigger
	 * @param {boolean} add - do we want to set or not set compare div
	 */
	function setCompareContainerDisplay(element, add, isNewTNPage) {
		if (!isNewTNPage) {
			return;
		}
		if (add) {
			if (findAncestor(element,'compareContainer')) {
				findAncestor(element,'compareContainer').classList.add('compared');
			} else {
				findAncestor(element,'product').children[2].classList.add('compared');
			}
		} else {
			if (findAncestor(element,'compareContainer')) {
				findAncestor(element,'compareContainer').classList.remove('compared');
			} else {
				findAncestor(element,'product').children[2].classList.remove('compared');
			}
		}
	}

	/**
	 * Method to find parent element based on class (cls) from original element (el)
	 * @param {element} el - element to search from
	 * @param {class} cls - class of element to search for
	 */
	function findAncestor(el, cls) {
		while (el && el.parentElement) {
			el = el.parentElement;
			if (el.classList.contains(cls)) {
				return el;
			}
		}
		return false;
	}

	/**
	 * Function to update compare check boxes on page load by reading from the compare Cookie
	 * @param {boolean} isProductPage
	 * @param {boolean} isNewTNPage
	 */
	function updateCompareCheckBoxOnLoad(isProductPage, isNewTNPage) {
		// remove any previously set checkboxes
		// get all elements with the compareProductCheckbox name and uncheck
		// this is used to handle Chrome's back button issue.
		var currentCheckboxes = document.getElementsByName('compareProductCheckbox');

		for (var checkboxCount = 0; checkboxCount < currentCheckboxes.length; checkboxCount++) {
			currentCheckboxes[checkboxCount].checked = false;
		}

		var compareCookie = RS.Utils.Cookies.getCookie('compareProducts');
		if (compareCookie) {
			var cookieArray = compareCookie.split(COMPARE_COOKIE_SEPARATOR);
			var noOfProducts = cookieArray.length;
			var element;
			var isAnyProductSelected = false;
			for (var i = 0; i < noOfProducts; i++) {
				element = document.getElementById(COMPARE_PREFIX + cookieArray[i]);
				if (element) {
					element.checked = true;
					isAnyProductSelected = true;
					setCompareContainerDisplay(element, true, isNewTNPage);
				}
			}
			updatePageSpecificData(isProductPage, isAnyProductSelected, compareCookie);
		}
	}

	/**
	 * Method to update page specific data
	 * @param {boolean} isProductPage
	 * @param {boolean} isAnyProductSelected
	 * @param {Cookie} compareCookie
	 */
	function updatePageSpecificData(isProductPage, isAnyProductSelected, compareCookie) {
		if (isProductPage) {
			showHideComparePageLink(isAnyProductSelected);
		} else {
			enableDisableCompareSelectedBtn(compareCookie.length > 0);
			updateSelectedProductCount(compareCookie);
		}
	}
	/**
	 * Method to enable or disable the compare selected btn.
	 * Button would be available if atleast one product is selected/present in the cookie
	 * @param {boolean} isAnyProductSelected
	 */
	function enableDisableCompareSelectedBtn(isAnyProductSelected) {

		var compareEnabledBtn = document.getElementById('compareSelectedBtnEnabled');
		var compareDisabledBtn = document.getElementById('compareSelectedBtnDisabled');
		compareDisabledBtn.style.display = isAnyProductSelected ? 'none' : 'block';
		compareEnabledBtn.style.display = isAnyProductSelected ? 'block' : 'none';

	}

	/**
	 * Method to show or hide the compare selected link on the Product page
	 * @param {boolean} isProductSelected
	 */
	function showHideComparePageLink(isProductSelected) {
		var addToCompareLabelElem = document.getElementById('addToCompareLabel');
		var viewCompareLabelElem = document.getElementById('viewCompareLabel');
		addToCompareLabelElem.style.display = isProductSelected ? 'none' : 'block';
		viewCompareLabelElem.style.display = isProductSelected ? 'block' : 'none';
	}

	/**
	 * Method to update the count of products already chosen for compare
	 * @param {Cookie} compareCookie
	 */
	function updateSelectedProductCount(compareCookie) {
		var prodCountElement = document.getElementById('selProdCountForCompare');
		if (compareCookie) {
			var cookieArray = compareCookie.split(COMPARE_COOKIE_SEPARATOR);
			prodCountElement.innerHTML = cookieArray.length;
		} else {
			prodCountElement.innerHTML = 0;
		}
	}

	/**
	 * Method to add the given product to Cookie
	 * @param {productNumber} productNumber
	 * @param {Cookie} compareCookie
	 */
	function addProductToCookie(productNumber, compareCookie) {
		if (compareCookie) {
			if (compareCookie.indexOf(productNumber) === -1) {
				// Only add if rsStockNumber is not already present in the cookie
				compareCookie += COMPARE_COOKIE_SEPARATOR + productNumber;
			}
		} else {
			// Nothing in compare cookie yet
			compareCookie = productNumber;
		}
		return compareCookie;
	}

	/**
	 * Method to remove a given Product from Cookie
	 * @param {productNumber} productNumber
	 * @param {Cookie} compareCookie
	 */
	function removeProductFromCookie(productNumber, compareCookie) {
		var cookieArray = compareCookie.split(COMPARE_COOKIE_SEPARATOR);
		cookieArray = removeProductFromCookieArray(productNumber, cookieArray);
		return cookieArray.join(COMPARE_COOKIE_SEPARATOR);
	}

	/**
	 * Method to remove multiple products from Cookie.
	 * @param {productNumbers} productNumbers to remove.
	 */
	function removeMultipleProductsFromCookie(productNumbers) {
		var compareCookie = RS.Utils.Cookies.getCookie('compareProducts');
		var cookieArray = compareCookie.split(COMPARE_COOKIE_SEPARATOR);
		if (productNumbers) {
			for (var i = 0; i < productNumbers.length; i++) {
				cookieArray = removeProductFromCookieArray(productNumbers[i], cookieArray);
			}
			compareCookie = cookieArray.join(COMPARE_COOKIE_SEPARATOR);
			RS.Utils.Cookies.setCookie('compareProducts', compareCookie, 0);
		}
	}

	/**
	 * Method to check if the limit on number of products to be compared is reached
	 * @param {Cookie} compareCookie
	 */
	function isCompareLimitReached(compareCookie) {
		if (compareCookie && compareCookie.split(COMPARE_COOKIE_SEPARATOR).length >= MAX_PRODUCTS_TO_COMPARE) {
			return true;
		}
		return false;
	}

	/**
	 * Method to show the compare limit warning popup
	 * @param {boolean} isNewTNPage
	 */
	function showCompareLimitPopup(isNewTNPage) {
		if (!isNewTNPage) {
			document.getElementById('compareLimitPopup').click();
		}
	}

	/**
	 * Method to iterate and remove ProductNumber from cookieArray
	 * @param {productNumber} productNumber
	 * @param {Cookie} cookieArray
	 */
	function removeProductFromCookieArray(productNumber, cookieArray) {
		for (var i = 0; i < cookieArray.length; i++) {
			if (cookieArray[i] === productNumber) {
				cookieArray.splice(i, 1);
				break;
			}
		}
		return cookieArray;
	}

	return {
        updateCompareCookie: updateCompareCookie,
        updateCompareCheckBoxOnLoad: updateCompareCheckBoxOnLoad,
        removeMultipleProductsFromCookie: removeMultipleProductsFromCookie
    };
}());



//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/utils/productCompare.js
// module id = 61
// module chunks = 2 8